export const media = root => root
